import { Chip, Tooltip } from '@mui/material';
import Icon from '../../components/Icon';
import { User } from '../../database/user';

interface QuestionCostChipProps {
    cost: number;
    user: User;
}

const displayQuestionCost = (user: User, baseCost: number): number => {
    if (user.isArtist && user.artistInfo) {
        const questionCost = (baseCost * (1-user.artistInfo.applicationFee / 100)) - ((baseCost * 0.029 + 0.30));
        return Math.round(questionCost * 100) / 100;
    } else {
        return baseCost;
    }
}
const QuestionCostChip: React.FC<QuestionCostChipProps> = ({ cost, user }) => {
    const costTooltip = user.isArtist && user.artistInfo ? `Earnings for answering request: $${displayQuestionCost(user, cost).toFixed(2)}`
    : `Request cost: $${displayQuestionCost(user, cost).toFixed(2)}`
    return (
        <Tooltip title={costTooltip}>
            <Chip
                icon={<Icon name={'cost'} />}
                label={'$'+displayQuestionCost(user, cost).toFixed(2)}
                variant='outlined'
                color='success'
            />
        </Tooltip>
    );
};

export default QuestionCostChip;
